const lightTheme = {
  primary: "#fff",
  secondary: "#153550",

  textPrimary: "#000",
  textSecondary: "#0A1B32",

  subColor: "#1D4160",
  error: "",
  success: "",
  info: "",
  warning: "",

  cardBorder: "1px solid #C6C6C6",
  cardBackground: "#fff",

  backgroundPrimaryHover: "rgba(21,53,80, 0.9)",
  backgroundSecondaryHover: "rgba(10, 27, 50, 0.9)",

  inputBackgroundColor: "#E7EFF8",
  inputFieldColor: "#fff",
  inputValueColor: "#000",

  activeColor: '#2C75EF',
  inActiveColor: "rgba(104,161,210, 0.5)",
};

const darkTheme = {
  primary: "#fff",
  secondary: "#0A1B32",

  textPrimary: "#0A1B32",
  textSecondary: "#fff",

  subColor: "#1D4160",

  error: "",
  success: "",
  info: "",
  warning: "",

  cardBorder: "transparent",
  cardBackground: "#153550",

  backgroundPrimaryHover: "rgba(10, 27, 50, 0.9)",
  backgroundSecondaryHover: "rgba(21,53,80, 0.9)",

  inputBackgroundColor: "#1E476E",
  inputFieldColor: "rgba(104,161,210, 0.5)",
  inputValueColor: "#fff",

  activeColor: '#2C75EF',
  inActiveColor: "rgba(104,161,210, 0.5)",
};

export type Theme = typeof lightTheme;

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
